import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

/**
 * Footer component for the application
 * Displays copyright information, links, and social media
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-section">
          <h3 className="footer-title"><i className="bi bi-music-note-beamed"></i> Unissn</h3>
          <p className="footer-description">
            Connecting musicians and artists to gigs and venues.
            The professional network for the music industry.
          </p>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-title"><i className="bi bi-compass"></i> Navigation</h3>
          <ul className="footer-links">
            <li><Link to="/"><i className="bi bi-house"></i> Home</Link></li>
            <li><Link to="/gigs"><i className="bi bi-calendar-event"></i> Find Gigs</Link></li>
            <li><Link to="/artists"><i className="bi bi-people"></i> Artists</Link></li>
            <li><Link to="/profile"><i className="bi bi-person"></i> Profile</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-title"><i className="bi bi-book"></i> Resources</h3>
          <ul className="footer-links">
            <li><Link to="/help"><i className="bi bi-question-circle"></i> Help Center</Link></li>
            <li><Link to="/terms"><i className="bi bi-file-text"></i> Terms of Service</Link></li>
            <li><Link to="/privacy"><i className="bi bi-shield-lock"></i> Privacy Policy</Link></li>
            <li><Link to="/contact"><i className="bi bi-envelope"></i> Contact Us</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-title"><i className="bi bi-globe"></i> Connect</h3>
          <div className="social-links">
            <a href="https://twitter.com/unissn" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="bi bi-twitter social-icon"></i>
            </a>
            <a href="https://facebook.com/unissn" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="bi bi-facebook social-icon"></i>
            </a>
            <a href="https://instagram.com/unissn" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="bi bi-instagram social-icon"></i>
            </a>
            <a href="https://linkedin.com/company/unissn" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="bi bi-linkedin social-icon"></i>
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <p className="copyright">
            <i className="bi bi-heart-fill"></i> &copy; {currentYear} Unissn. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
